import { createReducer } from '../../helpers/reducers';

import { types } from '../../actions/app';
import { types as typesEvents } from '../../actions/events';

const initialState = false;

const setTrue = () => true;
const setIsReady = (state, action) => action.payload.isReady;

const handlers = {
  [types.APP_SET_IS_READY]: setIsReady,
  [typesEvents.EVENTS_SHOW.SUCCESS]: setTrue,
  [typesEvents.EVENTS_SHOW.FAILURE]: setTrue,
};

const isReady = createReducer(initialState, handlers);

export default isReady;

export const getAppIsReady = state => state.app.isReady;



// WEBPACK FOOTER //
// ./src/reducers/app/isReady.js